import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        dark: true,
        themes: {
          dark: {
            background: '',
            primary: '#fff',
            secondary: '#000',
            accent: '#000244'
          },
        },
      }
});
